import { render } from "./Birthday.vue?vue&type=template&id=31a4b710&scoped=true"
import script from "./Birthday.vue?vue&type=script&lang=js"
export * from "./Birthday.vue?vue&type=script&lang=js"

import "./Birthday.vue?vue&type=style&index=0&id=31a4b710&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mamidou/mamidou/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a4b710"]])

export default __exports__